module.exports = __webpack_public_path__ + "static/media/a-3.adf1a68a.png";